<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: {
                type: Number,
                default: 0,
            },
            label: {
                type: String,
            },
            valueCurrency: {
                type: Number,
                default: 0,
            },
            cLabel: {
                type: String,
                default: 'IsoCode'
            },
            cLabelOptions: {
                type: String,
                default: 'label'
            },
            cDisabled: {
                type: Boolean,
                default: false,
            },
            currency: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            fixed: {
                type: Number,
                default: 2
            },
            min: {
                type: Number,
                default: -999999999999
            },
            max: {
                type: Number,
                default: 999999999999
            },
            bonus: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: this.validate('' + this.value),
                cur: 1,
                f: false,
                fs: false,
                old: 0,
                oldc: 0,
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/currency/get_list'
            }),
            event_load() {
                if (this.currency) this.$emit('load', this.load);
            },

            ms(v) {
                let mask = [];
                let a = this.validate(v).replace(/\d/g, '9').split('');
                a.forEach(i => {
                    if (i === '9') mask.push(/\d/);
                    if (i === '.') mask.push(/[\.,]/);
                    if (i === ' ') mask.push(' ');
                });
                return mask;
            },
            validate(v) {
                v = v.toString();
                if (v[0] === '-') {
                    v = v.replace(/\-/g, '');
                    v = '-' + v;
                } else {
                    v = v.replace(/\-/g, '');
                }
                let parts = v.toString().replace(/ /g, '').replace(/,/g, '.').replace(/^([^\.]*\.)|\./g, '$1').split(".");
                parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
                if (parts[1] && parts[1].length > this.fixed) parts[1] = parts[1].slice(0, this.fixed);
                return parts.join(".");

            },
            change(e) {
                if (this.val === '-') this.$emit('change', 0);
                else this.$emit('change', +(this.val.replace(/ /g, '').replace(/,/g, '.')));
            },

            select_focus() {
                this.fs = true;
            },
            select_blur() {
                if (this.cur !== this.oldc)
                    this.oldc = this.cur;

                this.fs = false;
            },
            setVal(v) {
                this.cur = v;
                this.$emit('update:valueCurrency', v);
                this.$emit('change-currency', v);
            }
        },
        computed: {
            ...mapState('dictionary/currency', {
                load: 'load',
                list: 'list'
            }),
            ...mapGetters('dictionary/currency', {
                national: 'national',
                getById: 'getById',
            }),
        },
        watch: {
            currency(v) {
                if (v) this.get_list();
            },
            load() {
                this.event_load();
            },
            valueCurrency(v) {
                this.cur = v;
                if (!this.fs) this.oldc = v;
            },
            value(v) {
                this.val = this.validate('' + v);
            },
            val(v) {
                if (v === '-') this.$emit('input', 0);
                else this.$emit('input', +(this.val.replace(/ /g, '').replace(/,/g, '.')));
            }
        },
        components: {},
        mounted() {
            if (this.currency) this.get_list();
            this.event_load();

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="input-price" :class="{'is-disabled':disabled}">
        <div class="el-input el-input--mini el-input-group" :class="{'is-disabled':disabled,'el-input-group--append':currency,'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <masked-input
                    type="text"
                    @change="change"
                    :value="val!=='0'?val:''"
                    @input="val=$event"
                    :mask="ms"
                    :guide="false"
                    placeholderChar="#"
                    class="el-input__inner"
                    :disabled="disabled">
            </masked-input>
            <div class="el-input-group__append" v-if="currency&&!bonus">
                <el-select :value="valueCurrency" @change="setVal" class="input-price__currency" :disabled="cDisabled||disabled"
                           :title="getById(valueCurrency)?getById(valueCurrency)[cLabelOptions]:''"
                           @focus="select_focus" @blur="select_blur">
                    <el-option v-for="item in list" :key="item.value" :value="item.value" :label="item[cLabel]||''">{{item[cLabelOptions]}}</el-option>
                </el-select>
            </div>
            <div class="el-input-group__append" v-if="currency&&bonus">Бонусы</div>
        </div>
        <div class="input__load" v-show="(load&&currency)">
            <i class="el-icon-loading"></i> Загрузка...
        </div>
    </div>
</template>

<style lang="scss">
    .input-price {
        position: relative;
        .el-input-group__append {
            .input-price {
                &__currency {
                    width: 80px;
                    .el-input {
                        &.is-disabled {
                            .el-input__inner {
                                cursor: default;
                            }
                            .el-input__suffix {
                                display: none;
                            }
                        }
                        &.is-focus {
                            .el-input__inner {
                                border-color: #6db234;
                                border-top: 1px solid;
                                border-bottom: 1px solid;
                                border-radius: 0 4px 4px 0;
                            }
                        }
                        .el-input__inner {
                            border-top: 1px solid #d8dce5;
                            border-bottom: 1px solid #d8dce5;
                            border-radius: 0 4px 4px 0;
                        }
                    }
                }
            }
        }
        &.is-disabled {
            .el-input-group__append {
                .input-price {
                    &__currency {
                        .el-input {
                            &.is-disabled {
                                .el-input__inner {
                                    cursor: not-allowed;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
